import { useRouter } from "next/router";
import React from "react";

import { SearchQuery } from "shared/data/reducers/types/storage";

import Checkbox from "@components/UI/Checkbox";
import FormattedMessage from "@components/UI/FormattedMessage";

interface Props {
  query: SearchQuery;
}

const FilterBoxReservationTerms: React.FC<Props> = ({ query }) => {
  const router = useRouter();

  const handleChange = () => {
    const newQuery = { ...query };

    if (query.refundableOnly) {
      delete newQuery.refundableOnly;
    } else {
      newQuery.refundableOnly = "true";
    }

    router.push(
      {
        pathname: router.pathname,
        query: newQuery,
      },
      undefined,
      { scroll: false }
    );
  };

  return (
    <div className="filters-box">
      <div className="filters-label">
        <FormattedMessage id="Filters.cancelPolicy" />
      </div>
      <div className="filter-stars-checkbox">
        <Checkbox
          customContainerClass="filter-airline-checkbox-container"
          customLabelClass="filter-airline-checkbox-label"
          label={<FormattedMessage id="Filters.refundableOnly" />}
          checked={!!query.refundableOnly}
          onClick={handleChange}
        />
      </div>
    </div>
  );
};

export default FilterBoxReservationTerms;
